<template>
  <v-snackbar
    v-model="flashMsgDisplaying"
    min-width="unset"
    :timeout="success ? 2000 : 5000"
    :color="success ? 'success' : 'error'"
    rounded="pill"
    content-class="text-center"
  >
    <v-icon color="white" class="mr-1">{{
      success ? "mdi-check-circle-outline" : "mdi-close-circle-outline"
    }}</v-icon>
    {{ success ? "Success!" : flashMsgTxt }}
  </v-snackbar>
</template>

<script>
// vuex
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FlashMessage",
  computed: {
    ...mapGetters("flashMessage", ["success", "showFlashMsg", "flashMsgTxt"]),
    flashMsgDisplaying: {
      get: function () {
        return this.showFlashMsg;
      },
      set: function () {
        return this.handleFlash({
          message: this.flashMsgTxt,
          success: this.success,
          show: false,
        });
      },
    },
  },
  methods: {
    ...mapActions("flashMessage", ["handleFlash"]),
  },
};
</script>

<style lang="scss" scoped></style>
